import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { faClock } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { CourtService } from '@shared/services';

@Component({
  selector: 'app-schedule-appointment-information',
  imports: [FontAwesomeModule],
  templateUrl: './schedule-appointment-information.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleAppointmentInformationComponent {
  private readonly _courtService = inject(CourtService);

  protected faClock = faClock;
  protected court = this._courtService.court;
}
